import { Spinner } from '../ui/spinner'
import styles from './Loading.module.css'

export function Loading({ label }: { label: string }) {
  return (
    <div className={styles.loading} role="status">
      <Spinner aria-hidden="true" />
      <span>{label}</span>
    </div>
  )
}
